/**
 * Project : workspace
 * File    : AppType.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package graph

enum class AppType {
    CUSTOMER, E_COMMERCE, BUSINESS, FRIENDLY, RISO, RISO_COUNCSELLOR
}

enum class PlatformType {
    iOS, Android, Web, Windows, linux, Mac, Mobile, Desktop
}
